<div class="modal-header main-modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
        (click)="closeModal()">×</button>
    <h4 class="modal-title wrap-text-in">Choose Credentials Type</h4>
</div>

<div class="modal-body">
        <div class="main-box-body">
            <form role="form" name="addCredentialsForm" novalidate autocomplete="off">
                <div class="row">
                    <div class="col-xs-12">
                        <div style="display:inline">
                            <div class="radio">
                                <input type="radio" name="usePassword" id="usePassword" [value]="true"
                                    [(ngModel)]="addJobBoardByPasswordFlag">
                                <label for="usePassword">
                                    Register Job Board credentials with username/password
                                </label>
                            </div>
                            <div class="radio">
                                <input type="radio" name="usePassword" id="doNotUsePassword" [value]="false"
                                    [(ngModel)]="addJobBoardByPasswordFlag">
                                <label for="doNotUsePassword">
                                    Re-use Job Board credentials with username/key
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
    </div>
    <div class="row">
            <div class="col-xs-12 text-right">
                <div class="clearfix">
                    <button type="button" class="btn btn-danger mr-2"
                        (click)="closeModal()">
                        <span>Cancel</span>
                    </button>
                    <button type="submit" class="btn btn-success"
                        (click)="onTypeSelected()">
                        <span>Ok</span>
                    </button>
                </div>
            </div>
        </div>
</div>
